import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;
declare var Dropzone: any;

export class newsletterTemplateImagesEdit_template extends vnTemplate {

    protected getTemplateHtml(): string {
        return `
            <div class="form-header">
                <h3 class="form-title">Header Image</h3>
                <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>
            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group row">
                        <label for="name" class="form-label form-label form-label-box">Name</label>
                        <input type="text" class="input-text" data-bind="value: name">
                    </div>
                    <div class="form-group">
                       <label class="form-label">Image</label>
                       <input id="newsletter-header-image" data-bind="value: image" type="hidden">
                       <!-- ko if: id -->
                       <div class="w-img" style="width: 32rem; height: 12rem; background: #f5f5f5; border: 1px solid #e0e0e0;">
                            <img data-bind="attr: { src: image, alt: name }" alt="" style="width: 100%; height: 100%; object-fit: contain; display: block;">
                       </div>
                       <!-- /ko -->
                       <!-- ko ifnot: id -->
                       <div id="dropzone">
                            <div id="newsletter-header-image-drop-zone" class="dropzone needsclick dz-clickable"></div>
                       </div>
                       <div class="form-note">Upload the newsletter header image that will be stored for this brand.</div>
                       <!-- /ko -->
                    </div>
                    <div class="form-group row">
                        <label for="width" class="form-label form-label form-label-box">Width</label>
                        <input type="text" class="input-text" data-bind="value: width, valueUpdate: 'afterkeydown'">
                    </div>
                    <div class="form-group row">
                        <label for="height" class="form-label form-label form-label-box">Height</label>
                        <input type="text" class="input-text" data-bind="value: height, valueUpdate: 'afterkeydown'">
                    </div>
                </div>
            </div>
            <div class="form-footer">
                <button data-bind="event: { click: onClickCancelEdit }" class="btn" type="button">Cancel</button>
                <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
            </div>
        `;
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-form"];
    }

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable(""),
            name: ko.observable(""),
            image: ko.observable(null),
            width: ko.observable(""),
            height: ko.observable(""),
            dropzone: ko.observable(null),
            onClickCancelEdit: function (data: any, event: any) {
                self.onClickCancelEdit();
            },
            onClickSave: function (data: any, event: any) {
                self.onClickSave()
            }
        }
    }

    protected getTemplateName(): string {
        return "newsletterTemplateImagesEdit_template";
    }

    public getViewModelForRequest(): any {

        return {
            id: this.getTemplateViewModel().id(),
            name: this.getTemplateViewModel().name(),
            image: this.getTemplateViewModel().image(),
            width: this.getTemplateViewModel().width(),
            height: this.getTemplateViewModel().height(),
        }
    }

    protected onClickCancelEdit(): any {
        this.caller.onClickCancelEdit();
    }

    protected onClickSave(): any {
        this.caller.save()
    }

    public setHeaderImage(image: any): void {
        this.getTemplateViewModel().id(image.id);
        this.getTemplateViewModel().name(image.name);
        this.getTemplateViewModel().width(image.width);
        this.getTemplateViewModel().height(image.height);
        this.setImage(image.value);
    }

    public setImage(image: any): void {
        this.getTemplateViewModel().image(image);
    }

    public generateDropzone(idBrand: any){
        let url = '/api/brand/' + idBrand + '/newsletter/templates/images/uploadImage/';
        let myDropzone = new Dropzone("div#newsletter-header-image-drop-zone", { url: url, maxFiles: 1, addRemoveLinks: true, dictRemoveFile: "Remove image", acceptedFiles: "image/jpeg,image/png,image/gif,image/webp"});
        this.getTemplateViewModel().dropzone(myDropzone);
        let _this = this;

        myDropzone.on("addedfile", function(file: any) {
            if (this.files.length > 1) {
                this.removeFile(this.files[0]);
            }
        });
        myDropzone.on("success", function(file: any, response: any) {
            let uploadedImage = response && response.images ? response.images[0] : null;
            if (uploadedImage) {
                _this.getTemplateViewModel().image(uploadedImage.url);
            }
        });
        myDropzone.on("error", function(file: any, response: any) {
            this.removeFile(file);
            _this.caller.onHeaderImageUploadError(response);
        });
        myDropzone.on("removedfile", function() {
            // Replacing a file removes the previous one before the new upload returns, so the url
            // is only cleared once the drop zone is actually empty.
            if (this.files.length === 0) {
                _this.getTemplateViewModel().image(null);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/newsletterTemplateImagesEdit_template.ts